import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LotState } from './lots.reducer';

export const selectLotState = createFeatureSelector<LotState>('activeLot');

export const selectActiveLot = createSelector(
  selectLotState,
  (state) => state.lot
);

export const selectActiveLotNegotiations = createSelector(
  selectLotState,
  (state) => state.negotiationDetails
);

export const selectActiveLotData = createSelector(
  selectLotState,
  (state) => state
);
